var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Toast',{attrs:{"no-auto-hide":"","variant":"danger","id":_vm.id,"title":_vm.title}},[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }